import React from 'react';
import Button from '../Button';

import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    borderTop: '2px solid #cfdae2',
    position: 'relative',
    marginTop: 8,
    marginBottom: 16,
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
      marginTop: 30,
    },
  },
  title: {
    fontSize: '16px',
    color: '#004987',
    margin: '-20px',
    padding: '0 10px',
    backgroundColor: '#fff',
    [theme.breakpoints.up('sm')]: {
      fontSize: '16px',
    },
  },
  imgContainer: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
}));

export default function GreenCard2(props) {
  const classes = useStyles();
  return (
    <>
      <Box classes={{ root: classes.container }}>
        <Box display='flex' justifyContent='center' mt='8px'>
          <Box
            classes={{ root: classes.title }}
            component='h3'
            fontWeight='fontWeightBold'
          >
            ¿Donde están los datos?{' '}
          </Box>
        </Box>
      </Box>
      <div mt='10px' className={classes.imgContainer}>
        <img src={require(`../../img/document/cedula3.png`)} alt='' />

        <img src={require(`../../img/document/cedula4.png`)} alt='' />
      </div>

      <div>
        <Button color='primary' onClick={() => props.closeModal(false)}>
          Volver
        </Button>
      </div>
    </>
  );
}
